<template>
  <div class="row">
    <loading
      :active.sync="loader.isLoading"
      :can-cancel="loader.canCancel"
      :is-full-page="loader.fullPage"
      :color="loader.color"
      :height="loader.height"
      :width="loader.width"
      :background-color="loader.backgroundColor"
      :loader="loader.loader"
    >
    </loading>
    <div class="col-md-12">
      <div class="card">
        <div class="card-header">
          <h5>Delivers</h5>
        </div>
        <div class="card-body">
          <div class="table-responsive">
            <div class="form-inline ml-auto">
              <div class="button-group">
                <button
                  type="button"
                  class="btn btn-sm btn-soft-primary waves-light waves-effect"
                  @click="addDelivery"
                >
                  <i class="fa fa-plus" aria-hidden="true"></i>
                </button>
                <button
                  type="button"
                  class="btn btn-sm btn-soft-primary waves-light waves-effect"
                  @click="refreshList"
                >
                  <i class="fa fa-refresh" aria-hidden="true"></i>
                </button>
                rows:
                <select
                  id="select-rows"
                  v-model="pageSize"
                  @change="setPageSizeOnChange"
                >
                  <option v-for="r in rowsTable" :key="r.row" :value="r.row">
                    {{ r.row }}
                  </option>
                </select>
                <span class="mr-1">
                  Total rows: <b>{{ rowsTotal }}</b>
                </span>
              </div>

              <div class="form-group mx-sm-3 mb-2">
                <input
                  type="search"
                  placeholder="search..."
                  class="form-control mr-1 input-search"
                  v-model="searchQuery"
                />
              </div>
              <span class="mr-1">
                page:
                <select v-model="currentPage">
                  <option v-for="p in pageLength" :key="p" :value="p">
                    {{ p }}
                  </option>
                </select>
                / {{ pageLength }}
              </span>
              <nav aria-label="Page navigation example" class="pull-right">
                <ul class="pagination">
                  <li class="page-item">
                    <a
                      class="btn btn-default btn-sm"
                      href="#"
                      @click="prevPage"
                    >
                      <i class="fa fa-angle-left" aria-hidden="true"></i>
                    </a>
                  </li>
                  <li class="page-item">
                    <a
                      class="btn btn-default btn-sm"
                      href="#"
                      @click="nextPage"
                    >
                      <i class="fa fa-angle-right" aria-hidden="true"></i>
                    </a>
                  </li>
                </ul>
              </nav>
            </div>
            <table class="table table-item mb-0 table-sm">
              <thead>
                <tr>
                  <th>
                    <label class="form-checkbox">
                      <input
                        type="checkbox"
                        v-model="selectAll"
                        @click="select"
                      />
                      <i class="form-icon"></i>
                    </label>
                  </th>
                  <th
                    v-for="t in title"
                    v-bind:key="t.prop"
                    @click="sortTable(t.prop)"
                  >
                    {{ t.name }}
                    <div
                      class="float-right fa"
                      v-if="t.prop == sortColumn"
                      v-bind:class="ascending ? 'fa-arrow-up' : 'fa-arrow-down'"
                    ></div>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="filterData.length < 1">
                  <td colspan="9" style="text-align: center"><i>No Data</i></td>
                </tr>
                <tr
                  v-for="u in filterData"
                  v-bind:key="u.id"
                  @click="editDelivery(u.id)"
                  style="cursor: pointer"
                >
                  <td>
                    <label class="form-checkbox">
                      <input type="checkbox" :value="u.id" v-model="selected" />
                      <i class="form-icon"></i>
                    </label>
                  </td>
                  <td>
                    <b>{{ u.deliver_no }}</b>
                  </td>
                  <td>
                    <b>{{ u.name }}</b>
                  </td>
                  <td>
                    <b>{{ u.address }}</b>
                  </td>
                  <td>
                    <b>{{ u.phone }}</b>
                  </td>
                  <td>
                    <b>{{ u.email }}</b>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <!-- <pre>{{ filterData }}</pre> -->
  </div>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import { deliveryUrl, getHeader } from '@/config'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

export default {
  name: 'DeliveryList',
  props: ['scroll'],
  components: {
    Loading
  },
  data () {
    return {
      dateNow: new Date(),
      loader: {
        isLoading: false,
        fullPage: true,
        color: '#007bff',
        canCancel: true,
        height: 128,
        width: 128,
        backgroundColor: '#ffffff',
        loader: 'spinner'
      },
      dataRaw: [],
      data: {},
      searchQuery: '',
      ascending: false,
      sortClick: false,
      sortColumn: '',
      pageSize: 10,
      currentPage: 1,
      title: [
        {
          name: 'Delivery Number',
          prop: 'deliver_no'
        },
        {
          name: 'Name',
          prop: 'name'
        },
        {
          name: 'Address',
          prop: 'address'
        },
        {
          name: 'Phone',
          prop: 'phone'
        },
        {
          name: 'Email',
          prop: 'email'
        }
      ],
      selectAll: false,
      selected: []
    }
  },
  mounted () {
    this.refreshList()
  },
  computed: {
    ...mapState({
      rowsTable: (state) => state.data.rowsTable
    }),
    pageLength: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.dataRaw.length
      } else {
        count = this.dataRaw
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).length
      }
      var length = count / this.pageSize

      return Math.ceil(length)
    },
    rowsTotal: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.dataRaw.length
      } else {
        count = this.dataRaw
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).length
      }
      // console.log(count)
      return count
    },
    filterData: function () {
      if (this.searchQuery.length > 0) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      }
      var col = this.sortColumn
      var ascending = this.ascending
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.dataRaw
        .sort(function (a, b) {
          if (a[col] > b[col]) {
            return ascending ? 1 : -1
          } else if (a[col] < b[col]) {
            return ascending ? -1 : 1
          }
          return 0
        })
        .filter((d) => {
          for (const name in d) {
            if (d[name] !== null) {
              if (
                d[name]
                  .toString()
                  .toLowerCase()
                  .indexOf(this.searchQuery.toLowerCase()) > -1
              ) {
                return d
              }
            }
          }
        })
        .filter((row, index) => {
          const start = (this.currentPage - 1) * this.pageSize
          const end = this.currentPage * this.pageSize
          if (index >= start && index < end) return true
        })
    }
  },
  methods: {
    setPageSizeOnChange: function () {
      this.currentPage = 1
    },
    sortTable: function sortTable (col) {
      this.currentPage = 1
      if (this.sortColumn === col) {
        this.ascending = !this.ascending
      } else {
        this.ascending = true
        this.sortColumn = col
      }
    },
    nextPage: function () {
      if (this.currentPage * this.pageSize < this.dataRaw.length) this.currentPage++
    },
    prevPage: function () {
      if (this.currentPage > 1) this.currentPage--
    },
    select () {
      this.selected = []
      this.currentPage = 1
      if (!this.selectAll) {
        for (const i in this.filterData) {
          this.selected.push(this.filterData[i].id)
        }
      }
    },
    editDelivery (id) {
      // this.data = this.dataRaw.find(todo => todo.id === id)
      axios
        .get(deliveryUrl + '/' + id, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then((response) => {
          this.$emit('editDelivery', response.data.data)
        })
        .catch((response) => {
          this.$swal('Error!!!', response, 'error')
        })
    },
    addDelivery () {
      this.$emit('newDelivery', true)
    },
    refreshList () {
      this.$Progress.start()
      this.loader.isLoading = true
      axios
        .get(deliveryUrl, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then((response) => {
          this.dataRaw = response.data.data
          this.$Progress.finish()
          this.loader.isLoading = false
          this.currentPage = 1
          this.searchQuery = ''
        })
        .catch((error) => {
          this.loader.isLoading = false
          if (error === 'Error: Network Error') {
            window.localStorage.removeItem('authUser')
            this.$router.push({ name: 'login' })
          } else if (
            error.response.data.message === 'This action is unauthorized.'
          ) {
            window.localStorage.removeItem('authUser')
            this.$router.push({ name: 'login' })
          }
        })
    }
  }
}
</script>
